import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { EditProfileForm } from '@/features/consumer/edit-profile-form';

export const Route = createFileRoute('/(consumer)/_authenticated/edit-profile')(
  {
    component: EditProfilePage,
  }
);

function EditProfilePage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/view-profile' })}
        />
        <HeaderDashboard.Title>Edit profile</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <EditProfileForm />
      </div>
    </div>
  );
}
